import React from "react";
import { useSpring, animated, easings } from "react-spring";
import { OpenAIOutlined, UserOutlined } from "@ant-design/icons";


function LoadCxMsg({ msg, showMaximumChat, customerStyles }) {
  const fadeInProps = useSpring({
    from: { opacity: Math.random() },
    to: { opacity: 1 },
    config: { duration: 1000, easing: easings.easeInOut },
    // Adjust duration and easing as needed
  });
  return (
    <>
      <div
        style={{
          customerStyles,
          alignItems: showMaximumChat && "flex-start",
          margin: showMaximumChat && "2%",
          flexWrap: showMaximumChat && "wrap",
        }}
        className="oneConversation-left-text-customer"
      >
        {showMaximumChat ? (
          <div
          
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              textAlign: "end",
              gap: "5px",
              marginLeft: "1px",
              // marginRight: "9rem"
            }}
          >
            {" "}
            <div
              style={{
                width: "30px",
                height: "30px",
                background: "#E20092",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
              }}
            >
              <UserOutlined  style={{ color: "white" }} />
            </div>
            <div
              style={{ whiteSpace: showMaximumChat && "nowrap" }}
              className="customer-text"
            >
              {msg.text}
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              textAlign: "end",
              width: "100%",
            }}
          >
            {" "}
            <div
              style={{ whiteSpace: showMaximumChat && "nowrap" }}
              className="customer-text"
            >
              {msg.text}
            </div>
            <div
              style={{
                width: "30px",
                height: "30px",
                background: "#E20092",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
              }}
            >
              <UserOutlined  style={{ color: "white" }} />
            </div>
          </div>
        )}
        <div
          className="user-time"
          style={{
            fadeInProps,
            marginLeft: showMaximumChat && "78px",
            marginTop: showMaximumChat && "4px",
          }}
        >
          {msg?.time}
        </div>
      </div>
    </>
  );
}

export default React.memo(LoadCxMsg);
